// API Configuration
// Automatically detects the base URL based on the current environment

const getApiBaseUrl = () => {
  // In production or staging, use the current origin
  // In development, use localhost:3000
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  
  // Use the current origin for production/staging
  return window.location.origin;
};

export const API_BASE_URL = getApiBaseUrl();
